import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import EmployeeProcessService from '../services/EmployeeProcessService';
import showToast from "../Utils/ToastContainer";
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
function EmployeeUpload() {
  const empcode = localStorage.getItem('empcode');
  const [file, setFile] = useState(null);
  const [selectedPlant, setSelectedPlant] = useState("");
  const [employeeMode, setEmployeeMode] = useState(0); // 0=Create, 1=Update
  const [employeeType, setEmployeeType] = useState(""); // 0=Contractual, 1=Permanent
  const [uploading, setUploading] = useState(false);
  const { setLoading } = useLoading();
  const [plant, setPlant] = useState([]);
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  useEffect(() => {
    loadDropdowns();
  }, []);
  const loadDropdowns = async () => {
    try {
      const [
        plantRes
      ] = await Promise.all([
        EmployeeProcessService.getPlant(empcode),
      ]);

      if (plantRes?.data?.statusCode === 200) setPlant(plantRes.data.result);

    } catch (error) {
      console.error("Error loading dropdowns:", error);
    }
  };
  const downloadExcel = (data, fileName = "UploadErrors.xlsx") => {
    if (!data || data.length === 0) {
      console.warn("No data to export.");
      return;
    }
    else { alert('Excel upload processed successfully.Please check the output Excel for remarks/messages.'); }
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Errors");

    XLSX.writeFile(workbook, fileName); // triggers browser download
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    debugger;
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }
    if (!selectedPlant) {
      alert("Please select a Plant.");
      return;
    }

    if (employeeMode === null || employeeMode === undefined) {
      alert("Please select Create/Update mode.");
      return;
    }

    if (employeeType === '' || employeeType === undefined) {
      alert("Please select Employee Type.");
      return;
    }
    const modeText = employeeMode === 0 ? "CREATE (Insert)" : "UPDATE";
    const confirmMsg = `Are you sure you want to ${modeText} employee data?`;

    if (!window.confirm(confirmMsg)) {
      return; // ❌ stop upload
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("employeeMode", employeeMode); // ✅ send dropdown value
    formData.append("Plant", selectedPlant);
    formData.append("Type", employeeType);
    const message = "";
    try {
      setUploading(true);

      const response = await EmployeeProcessService.setEmployeeUpload(formData);

      if (response.success && response.data.statusCode === 200) {
        const result = response?.data?.result || [];
        downloadExcel(result, "UploadErrors.xlsx");
        setLoading(false);
      }
      // When API returns any handled error (statusCode 400, 500, etc.)
      else if (response.data && response.data.message) {
        alert(response.data.message);
      }
      // When API response is empty or unexpected
      else {
        alert("Unexpected response from server.");
      }

    } catch (error) {
      // When axios throws (e.g., server down or unhandled error)
      console.error("Upload failed:", error);

      if (error.response && error.response.data && error.response.data.message) {
        // API threw an exception with structured response
        alert(error.response.data.message);
      } else {
        // Generic error
        alert("Upload failed due to server error.");
      }

      toast.error("Upload failed due to server error.");
    } finally {
      setUploading(false);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleUpload} className="upload-form">
      <div className="row">
        <div className="col-6 mb-3 border-bottom pb-2">
          <h4 className="text-left text-primary">Employee Upload</h4>
          <button
            type="button"
            onClick={async () => {
              const success = await EmployeeProcessService.getTemplate("PermanentEmployeeUpload.xlsx");
              if (success) {
                showToast("Template downloaded successfully.", "success");
              }
            }}
            className="btn btn-outline-success"
          >
            Download Permanent Employee Template
          </button>
        </div>
        <div className="col-6 mb-3 mt-4 border-bottom pb-2">
          <h4 className="text-left text-primary"></h4>
          <button
            type="button"
            onClick={async () => {
              const success = await EmployeeProcessService.getTemplate("ContractualEmployeeUpload.xlsx");
              if (success) {
                showToast("Template downloaded successfully.", "success");
              }
            }}
            className="btn btn-outline-success"
          >
            Download Contractual Employee Template
          </button>
        </div>
        <div className="form-group col-md-3">
          <label>File</label>
          <input type="file" onChange={handleFileChange} />
        </div>
        <div className="form-group col-md-3">
          <label>Plant<span style={{ color: 'red' }}>*</span></label>
          <select
            className="form-select"
            value={selectedPlant}
            onChange={(e) => setSelectedPlant(e.target.value)}
          >
            <option value="">Select Plant</option>
            {plant.map(plan => (
              <option key={plan.id} value={plan.id}>
                {plan.name}
              </option>
            ))}
          </select>

        </div>
        <div className="form-group col-md-3">
          <label>Create/ Update</label>
          <select
            className="form-control"
            value={employeeMode}
            onChange={(e) => setEmployeeMode(Number(e.target.value))}
          >
            <option value={0}>Employee Create</option>
            <option value={1}>Employee Update</option>
          </select>
        </div>
        <div className="form-group col-md-3">
          <label>Employee Type</label>
          <select
            className="form-control"
            value={employeeType}
            onChange={(e) => setEmployeeType(Number(e.target.value))}
          >
            <option value="">Select Type</option>
            <option value="0">Contractual Employee</option>
            <option value="1">Permanent Employee</option>
          </select>
        </div>

        <div className="form-group mt-0 col-md-2">
          <button type="submit" disabled={uploading}>
            {uploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </form>
  );
}

export default EmployeeUpload;
